var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F8F9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5803 13.4093C12.7933 11.1963 16.3812 11.1963 18.5942 13.4093C20.8072 15.6223 20.8072 19.2102 18.5942 21.4232L15.2944 24.723C13.0814 26.936 9.49348 26.936 7.28051 24.723C5.06754 22.51 5.06754 18.9221 7.28051 16.7091L10.5803 13.4093ZM16.2372 15.7663C15.326 14.8551 13.8486 14.8551 12.9374 15.7663L9.63753 19.0661C8.72631 19.9774 8.72631 21.4547 9.63753 22.366C10.5488 23.2772 12.0261 23.2772 12.9374 22.366L16.2372 19.0661C17.1484 18.1549 17.1484 16.6775 16.2372 15.7663Z",
    fill: "#8B919E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7218 7.28038C22.5088 5.0674 18.9209 5.06741 16.7079 7.28038L13.4081 10.5802C12.9103 11.0779 12.5246 11.6452 12.2507 12.2508C13.6218 11.6311 15.189 11.5853 16.5891 12.1133L19.0649 9.6374C19.9762 8.72618 21.4535 8.72618 22.3648 9.6374C23.276 10.5486 23.276 12.026 22.3648 12.9372L19.0649 16.2371C18.1537 17.1483 16.6763 17.1483 15.7651 16.2371C15.4541 15.9261 15.2492 15.5491 15.1505 15.1512C14.3825 14.9605 13.5364 15.1653 12.936 15.7657L12.1124 16.5893C12.3879 17.3203 12.8198 18.0058 13.4081 18.5941C15.621 20.8071 19.209 20.8071 21.422 18.5941L24.7218 15.2943C26.9348 13.0813 26.9348 9.49335 24.7218 7.28038Z",
    fill: "#B7BDCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.2f4285194b6569ae1b131e8a89dd987c.svg";
export { ForwardRef as ReactComponent };